import TagManager from "react-gtm-module";

function UnsubscribeFromAllButton({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "unsubscribe_from_all_button",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default UnsubscribeFromAllButton;
